import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { toggleModal } from '../../../../reducers/modalReducer';

const TABS = ['Dashboard', 'Analyser', 'AnyLists', 'Workflows', 'ResearchAid', 'InvestorMatch', 'AppStore'];

/**
 * Reusable company sub-navigation tabs.
 *
 * @param {string}   companyId       - Current company id (used when navigating)
 * @param {string}   [activeTab]     - Currently active tab name (highlights it). Omit for no highlight.
 * @param {function} [onTabChange]   - Called with the tab name when clicked (inline mode)
 * @param {boolean}  [navigateOnClick] - If true, clicking navigates to /company-old/:id instead of calling onTabChange
 * @param {string}   [className]     - Extra wrapper class names
 */
export default function CompanyTabs({ company, companyId, activeTab, onTabChange, navigateOnClick = false, className = '', }) {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const user = useSelector(state => state.user);

    if (user?.['type'] === 'Superflow' || user?.['type'] === 'External') return null;

    const isGuest = user?.['role'] === 'Guest';
    const hideInvestorMatch = user?.['role'] === 'Advisor' || user?.['role'] === 'Investor' || company?.['testType'] == "growth" || company?.['testType'] == "exit";

    const handleClick = (item) => {
        if (item === 'InvestorMatch') {
            if (navigateOnClick) {
                dispatch(toggleModal({ open: 'investorMatchDisclaimer' }));
                return;
            }
            if (activeTab !== item) {
                dispatch(toggleModal({ open: 'investorMatchDisclaimer' }));
                return;
            }
        }

        if (navigateOnClick) {
            navigate(`/company-old/${companyId}`, { state: { activeTab: item } });
        } else if (onTabChange) {
            onTabChange(item);
        }
    };

    return (
        <div className={`tabs-navlist tabs-dashboard df aic jcc mt2rem ${className}`.trim()}>
            {TABS.map((item, idx) => {
                if (hideInvestorMatch && item === 'InvestorMatch') return null;
                return (
                    <div key={`company-tab-${idx}`} className="df fdc">
                        <button
                            disabled={isGuest}
                            className={`fs1-25rem fw500 c15 ${activeTab === item ? ' active' : ''}`}
                            onClick={() => handleClick(item)}
                            style={{ cursor: isGuest ? 'not-allowed' : 'pointer' }}
                        >
                            {item}
                        </button>
                    </div>
                );
            })}
        </div>
    );
}
